var render = function render(){var _vm=this,_c=_vm._self._c;return _c('project-details-full',{attrs:{"projectId":_vm.projectId,"showHistory":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }